import React from 'react';
import ShopifyPartnerLogo from '../../assets/images/icons/shopify-partner.svg';
import { useIntl } from 'react-intl';

const Partner = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="partner-container">
      <div className="partner-header-content-wrapper">
        <div className="partner-content">
          <div className="partner-content">
            <div className="partner-section-title">
              <h3>{formatMessage({ id: 'partnerTitle' })}</h3>
            </div>
            <div className="partner-section-title2">
              <h3>{formatMessage({ id: 'partnerTitle2' })}</h3>
            </div>
          </div>
          <div className="partner-content">
            <p>{formatMessage({ id: 'partnerContent' })}</p>
            <p>{formatMessage({ id: 'partnerContent2' })}</p>
          </div>
        </div>
        <div className="img-wrapper">
          <img src={ShopifyPartnerLogo} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Partner;
